var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "btn btn-purple ml-2 text-uppercase",
        attrs: { disabled: !_vm.hasSelected && !_vm.canExport },
        on: { click: _vm.onExport },
      },
      [_vm._v("Export to csv\n  ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }